<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="hitValue"
    :data="sugestedItems"
    :serializer="(item) => item.nome"
    :placeholder="placeholder"
    :maxMatches="maxQuantity"
    class="form-control form-control-custom form-bag-select"
    :class="[stateClass]"
    :show-all-results="showAllResults"
    show-on-focus
    disable-sort
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import _ from "lodash";
import { slugify } from "@/helpers/functions/slugify";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {
      type: Number,
      default: null,
    },
    return_object: false,
    placeholder: {
      type: String,
      default: "Selecione um Conselho",
    },
    size: {
      type: String,
      default: "md",
    },
    addNullValue: {
      type: Boolean,
      default: false,
    },
    showAllResults: {
      type: Boolean,
      default: true,
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    input_value: null,
    items: [],
  }),
  computed: {
    formatedItems() {
      const items = this.items || [];
      if (this.addNullValue) {
        items.unshift({
          id: null,
          nome: "--",
        });
      }
      return items;
    },
    sugestedItems() {
      const allItems = this.formatedItems;
      const matchCase = slugify(this.search);
      const re = new RegExp(matchCase, "gi");
      const matcheValue = (item) => slugify(item.nome).match(re);
      const filterByNameCaseSensitive = (item) => matcheValue(item) !== null;
      return allItems.filter(filterByNameCaseSensitive);
    },
    maxQuantity() {
      return this.formatedItems.length;
    },
  },
  methods: {
    ...mapActions("conselhos", ["ActionFindToSelect"]),
    setById(id) {
      const selected = _.find(this.items, { id: id });
      if (selected) {
        this.search = selected.sigla ? selected.sigla.toUpperCase() : "";
        this.input_value = selected;
      }
    },
    hitValue($event) {
      this.input_value = $event;
      this.$emit("change", this.input_value);
    },
    getConselho() {
      const selected = _.find(this.items, { id: this.value });
      return selected;
    },
    async loadData() {
      try {
        const response = await this.ActionFindToSelect({
          per_page: 500,
        });
        this.items = response.data;
      } catch (error) {}
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.$emit("input", null);
      }
    },
    input_value() {
      if (this.return_object) {
        this.$emit("input", this.input_value);
      } else {
        this.$emit("input", this.input_value.id);
      }
    },
    value: function (id, old) {
      if (id != old) {
        this.setById(id);
      }
    },
  },
  async created() {
    await this.loadData();
    if (this.value) {
      this.setById(this.value);
    }
  },
};
</script>
